enum BiteLogOloPayKioskEvent {
  /** @deprecated This event is not made as of 2025-06-02, Keep until 9/2 for parsing purposes */
  PaymentDeprecated = 1,
  /** @deprecated This event is not made as of 2025-06-02, Keep until 9/2 for parsing purposes */
  PaymentErrorDeprecated = 2,
  /** @deprecated This event is not made as of 2025-06-02, Keep until 9/2 for parsing purposes */
  RefundDeprecated = 3,
  /** @deprecated This event is not made as of 2025-06-02, Keep until 9/2 for parsing purposes */
  RefundErrorDeprecated = 4,
  TerminalDisconnected = 5,
}

export { BiteLogOloPayKioskEvent };
